import { render, staticRenderFns } from "./crossCenter.vue?vue&type=template&id=54609108"
import script from "./crossCenter.vue?vue&type=script&lang=js"
export * from "./crossCenter.vue?vue&type=script&lang=js"
import style0 from "./crossCenter.vue?vue&type=style&index=0&id=54609108&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports